module.exports = __webpack_public_path__ + "static/media/ordinary-day.0da0323c.png";